import React, { useState } from "react";
import { api } from "@/lib/api";
import { Btn } from "@/components/site/Buttons";
import { Mail, Check } from "lucide-react";
import { toast } from "sonner";
import { ILL } from "@/assets/illustrations";
import { useAntiSpam } from "@/components/site/AntiSpam";

export function NewsletterBox({
  title = "Scarica gratuitamente la guida per organizzare i tuoi viaggi in autonomia.",
  text = "Iscriviti alla newsletter: itinerari testati, budget reali e strumenti utili, senza spam.",
  source = "site",
  variant = "peach",
}) {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const { getPayload, honeypot } = useAntiSpam();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/newsletter/subscribe", { email, name, source, origin_url: window.location.origin, ...getPayload() });
      setDone(true);
      toast.success("Controlla la tua email per confermare l'iscrizione.");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Qualcosa è andato storto.");
    } finally {
      setLoading(false);
    }
  };

  const bg = variant === "green" ? "bg-vs-green text-white" : "bg-vs-peach text-vs-text";

  return (
    <div className={`relative overflow-hidden rounded-[2.25rem] ${bg} p-8 md:p-14 shadow-vs-soft vs-grain`} data-testid="newsletter-box">
      <div className="pointer-events-none select-none absolute -right-4 -top-4 w-28 md:w-36 aspect-square rounded-full overflow-hidden ring-4 ring-white/50 shadow-xl hidden sm:block rotate-6">
        <img src={ILL.plane} alt="" aria-hidden className="w-full h-full object-cover" />
      </div>
      <div className="relative max-w-2xl">
        <Mail className={`w-10 h-10 mb-4 ${variant === "green" ? "text-vs-peach" : "text-vs-orange"}`} strokeWidth={1.5} />
        <h3 className="text-2xl md:text-4xl font-extrabold leading-tight tracking-tight">{title}</h3>
        <p className={`mt-4 text-base md:text-lg ${variant === "green" ? "text-white/85" : "text-vs-text/75"}`}>{text}</p>
        {done ? (
          <div className="mt-6 inline-flex items-center gap-2 font-bold" data-testid="newsletter-success">
            <Check className="w-5 h-5" /> Controlla la tua email per confermare ✉️
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6 flex flex-col sm:flex-row gap-3">
            {honeypot}
            <input
              type="text"
              placeholder="Il tuo nome"
              value={name}
              onChange={(e) => setName(e.target.value)}
              aria-label="Il tuo nome"
              className="flex-1 rounded-full px-5 py-3.5 text-vs-text bg-white/95 outline-none focus:ring-2 focus:ring-vs-orange"
              data-testid="newsletter-name-input"
            />
            <input
              type="email"
              required
              placeholder="La tua email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              aria-label="La tua email"
              className="flex-1 rounded-full px-5 py-3.5 text-vs-text bg-white/95 outline-none focus:ring-2 focus:ring-vs-orange"
              data-testid="newsletter-email-input"
            />
            <Btn type="submit" disabled={loading} data-testid="newsletter-submit-button">
              {loading ? "Invio..." : "Iscriviti"}
            </Btn>
          </form>
        )}
      </div>
    </div>
  );
}
